<div class="detail-page asiakas-katsele">
  <app-asiakas-otsikko otsikko="Laskunasiakas" [asiakas]="asiakas()"></app-asiakas-otsikko>

  <div class="toiminnot-yla">
    <app-secondary-button (click)="takaisin()" actionId="Palaa asiakasselauslistaan">Takaisin listaan</app-secondary-button>
  </div>

  @if (laskunAsiakasObservable | async; as la) {
    <div class="tiedot-grid">
      <div class="kentta">
        <div class="otsikko">Ulkoinen tunniste</div>
        <div class="arvo mono">{{ la.ulkoinenTunniste || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Avain</div>
        <div class="arvo mono">{{ la.avain }}</div>
      </div>

      <div class="kentta laaja">
        <div class="otsikko">Nimi</div>
        <div class="arvo">{{ la.nimi }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Y-tunnus</div>
        <div class="arvo mono">{{ la.ytunnus || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Asiakastyyppi</div>
        <div class="arvo">{{ la.asiakastyyppi === 'h' ? 'Henkilö' : 'Yritys' }}</div>
      </div>

      <div class="kentta laaja">
        <div class="otsikko">Katuosoite</div>
        <div class="arvo">{{ la.katuosoite || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Postinumero</div>
        <div class="arvo mono">{{ la.postinro || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Toimipaikka</div>
        <div class="arvo">{{ la.postitmp || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Maa</div>
        <div class="arvo">{{ la.maa || '–' }}</div>
      </div>

      <div class="kentta">
        <div class="otsikko">Verkkolaskuosoite</div>
        <div class="arvo mono">{{ la.sahkoinenosoite?.sahkoinenOsoite || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Verkkolaskun välittäjä</div>
        <div class="arvo mono">{{ la.sahkoinenosoite?.sahkoinenValittaja || '–' }}</div>
      </div>

      <div class="kentta laaja">
        <div class="otsikko">Laskun vastaanottajat (sähköposti)</div>
        @if (la.laskunVastaanottajat?.length) {
          <ul class="arvo lista">
            @for (s of la.laskunVastaanottajat; track s) {
              <li>{{ s }}</li>
            }
          </ul>
        } @else {
          <div class="arvo">–</div>
        }
      </div>

      <div class="kentta">
        <div class="otsikko">Laskun tyyppi</div>
        <div class="arvo mono">{{ la.laskunTyyppi || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Kieli</div>
        <div class="arvo">{{ la.laskunKieli || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Valuutta</div>
        <div class="arvo">{{ la.laskunValuutta || '–' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Viimeisin lähetystapa</div>
        <div class="arvo mono">{{ la.viimeisinLaskuLahetetty || '–' }}</div>
      </div>

      <div class="kentta">
        <div class="otsikko">Lisätty</div>
        <div class="arvo">{{ la.date?.toDate() | date: 'dd.MM.yyyy HH:mm' }}</div>
      </div>
      <div class="kentta">
        <div class="otsikko">Poistettu</div>
        <div class="arvo">{{ la.poistettu ? 'Kyllä' : 'Ei' }}</div>
      </div>
    </div>
  } @else {
    <div class="tyhja-tila">Asiakasta ei löytynyt.</div>
  }
</div>
